import { render, staticRenderFns } from "./collaborators-list.vue?vue&type=template&id=265f7e3c&scoped=true&"
import script from "./collaborators-list.ts?vue&type=script&lang=ts&"
export * from "./collaborators-list.ts?vue&type=script&lang=ts&"
import style0 from "./collaborators-list.scss?vue&type=style&index=0&id=265f7e3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265f7e3c",
  null
  
)

export default component.exports